import { render, staticRenderFns } from "./TasksThisWeek.vue?vue&type=template&id=7ef0a06a&scoped=true"
import script from "./TasksThisWeek.vue?vue&type=script&lang=js"
export * from "./TasksThisWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef0a06a",
  null
  
)

export default component.exports